import { FC } from 'react';

import { ExpiredIcon } from '../../icons';

import { ImageOverlayWrapper } from './ImageOverlayWrapper';
import { programStateFallbackLabel } from './programStateLabel';

import styles from './OverlayIcon.module.css';

interface Props {
  iconSize?: 'normal' | 'large';
  label?: string;
}
export const ExpiredOverlay: FC<Props> = ({ iconSize = 'normal', label }) => {
  const marginBottom = label ? '.5rem' : '0';
  const ariaLabel = label ? label : programStateFallbackLabel.expired;

  return (
    <ImageOverlayWrapper centerContent backdropStyle="dark" label={label} aria-label={ariaLabel}>
      <ExpiredIcon className={styles.overlayIcon} iconSize={iconSize} style={{ marginBottom, color: 'white' }} />
    </ImageOverlayWrapper>
  );
};
